import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StringRen from "csi/heading/String";
import declare from "dojo/_base/declare";

const StringMapRenderer = declare(StringRen, {

	/** @property {boolean} shouldLineBreak - if true add an extra line in-between key value pairs */ 
	shouldLineBreak: true,

	/**
	 * @override
	 * Format StringMap values to have newline after each value
	 */
	formatValue: function(value: any, fmt: string) {
		return JSON.stringify(value);
	},

	/**
	 * @override
	 * Add New Line Separators between each key value pair in StringMap
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: HTMLElement): boolean {
		let stringVal = this.toValue(ctx, h);
		// Remove the brackets from JSON string
		stringVal = stringVal.substring(1, stringVal.length-1);
		// Remove all " from the string
		stringVal = stringVal.replace(/["]+/g, "");
		const valElements = stringVal.split(",");

		const numParameters = valElements.length;
		for (let i=0; i < valElements.length-1; i++) {
			refNode.appendChild(document.createTextNode(valElements[i] + ","));
			refNode.appendChild(document.createElement("br"));
			if (this.shouldLineBreak) {
				refNode.appendChild(document.createElement("br"));
			}
		}
		refNode.appendChild(document.createTextNode(valElements[numParameters-1]));

		return true;
	},
});

export = StringMapRenderer;